<template lang="html">
<div class="outlets">
  <row>
    <div class="sl-col-4">
      <div class="sl-condition">
        <row>
          <div class="col-md-4">
            <div class="form-group">
              <el-input v-model="condition.search" :placeholder="$t('Placeholder.OutletSearch')" @keyup.native.enter="searchByCondition"></el-input>
            </div>
          </div>
          <div class="col-md-8 sm-margin">
            <div class="form-group">
              <sl-btn class="sl-btn-lightblue" :text="$t('Functional.confirm')" @click.native="searchByCondition"></sl-btn>
              <router-link class="sl-el-btn sl-btn-green" tag="el-button" :to="{ name: 'Add-New-Outlet' }" @click.native="$ga.event('Link', 'Add new store', 'Stores')">+ {{$t('Button.addNewOutlet')}}</router-link>
            </div>
          </div>
        </row>
      </div>
    </div>
  </row>
  <row>
    <div class="sl-col-4">
      <div class="sl-body" v-loading="loading">
        <row class="sl-table-reload" v-show="reloadBtn"> {{$t('Notify.errorMsg')}}
          <sl-btn class="sl-btn-lightblue" :text="$t('Functional.reload')" @click.native="reloadTable"></sl-btn>
        </row>
        <el-table :data="tableData" style="width: 100%" @sort-change="handleSortChange" border>
          <el-table-column min-width="200" :fixed="$store.state.userAgent.isPhone ? false : 'left'" :show-overflow-tooltip="true" prop="name" :label="$t('Views.Outlets.table.name')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="address" :label="$t('Views.Outlets.table.address')" :formatter="formatterAddress"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="contact" :label="$t('Views.Outlets.table.contact')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="phone" :label="$t('Views.Outlets.table.phone')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="status" label="Approval status" :formatter="formatterStatus"> </el-table-column>
          <el-table-column :min-width="$store.state.userAgent.isPhone ? 150 : 200" fixed="right" :label="$t('Table.actions')">
            <template scope="scope">
              <el-button class="sl-edit" size="small" @click="edit(scope.row.id)">{{$t('Table.edit')}}</el-button>
              <el-button class="sl-detail"  size="small" @click="gotoPage(scope.row.id)">{{$tc('Table.view',1)}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="!reloadBtn" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.per" layout="prev, pager, next, sizes,jumper,total" :total="table.total"> </el-pagination>
      </div>
    </div>
  </row>
</div>
</template>
<style>
.outlets div.sl-body td .cell.el-tooltip {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}

.outlets div.sl-body th .cell {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}
</style>
<script>
import api from '../../../api'
import * as types from '../../../store/types'
import _ from 'lodash'
const status = [
  {
    id: '0',
    value: 'Processing'
  },
  {
    id: '1',
    value: 'Approved'
  },
  {
    id: '2',
    value: 'Rejected'
  },
  {
    id: '3',
    value: 'Disabled'
  }
]
export default {
  name: 'Outlets',
  data() {
    return {
      loading: false,
      tableData: [],
      table: this.$store.state.stores.table,
      condition: this.$store.state.stores.condition,
      reloadBtn: false
    }
  },
  methods: {
    reloadTable() {
      this.$ga.event('Button', 'Reload', 'Stores')
      updateTable(this, initParams(this.table, this.condition, this.datePicker))
    },
    gotoPage(id) {
      this.$ga.event('Link', 'Detail', 'Stores')
      this.$router.push({
        name: 'View-Outlet-Detail',
        params: {
          id: id
        }
      })
    },
    edit(id) {
      this.$ga.event('Link', 'Edit', 'Stores')
      this.$router.push({
        name: 'Update-Outlet',
        params: {
          id: id
        }
      })
    },
    formatterAddress(row, column) {
      return [row.country, row.state, row.city, row.address1, row.address2].join(' ')
    },
    formatterStatus(row, column) {
      const index = _.findIndex(status, {
        'id': row.status
      })
      return status[index].value
    },
    handleSizeChange(per) {
      this.table.per = per
      updateTable(this, initParams(this))
    },
    handleCurrentChange(page) {
      this.table.page = page
      updateTable(this, initParams(this))
    },
    searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Stores')
      updateTable(this, initParams(this))
    },
    // clearSelectors() {
    //   this.$ga.event('Button', 'ClearAll', 'Stores')
    //   this.condition = {
    //     search: ''
    //   }
    // },
    handleSortChange({
      column,
      prop,
      order
    }) {
      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      }
      updateTable(this, initParams(this))
    }
  },
  created() {
    updateTable(this, initParams(this))
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'Update-Outlet' && to.name !== 'View-Outlet-Detail') {
      this.$store.commit(types.InitStoreTable)
    }
    next()
  }
}

function updateTable(vm, params) {
  vm.loading = true
  api.FetchOutletsTable(params).then(res => {
    const result = res.data.data
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    }
    vm.tableData = result.list
    vm.reloadBtn = vm.loading = false
  }).catch(error => {
    console.log(error)
    vm.tableData = []
    vm.loading = false
    vm.reloadBtn = true
  })
}
// 初始化table请求接口的参数
function initParams(vm) {
  vm.$store.commit(types.SetStoreTable, {
    table: Object.assign({}, vm.table),
    condition: Object.assign({}, vm.condition)
  })
  const ts = Object.assign({}, vm.$store.state.stores)
  let tb = JSON.parse(JSON.stringify(ts.table))
  let cd = JSON.parse(JSON.stringify(ts.condition))
  delete tb.total
  return Object.assign({}, tb, cd)
}
</script>

<style>
.outlets div.sl-body td .cell.el-tooltip {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}

.outlets div.sl-body th .cell {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// outlets.vue?3d1e0bf4